import { useEffect } from 'react';
import UniHeader from './components/UniHeader/UniHeader';
import './globals.scss';
import './styles/ProtectedApp.scss';
import UniFooter from './components/UniFooter/UniFooter';
import { useTranslation } from 'react-i18next';
import { useUserStore } from './store/user';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './helpers/authProvider';
import UniMenu from './components/UniMenu/UniMenu';
import { getUserDataBackoffice } from './services/userService';

function ProtectedApp(props: any) {

  const { i18n } = useTranslation();
  const { lng, darkMode, changeLoginData } = useUserStore();

  useEffect(() => {    
    if (lng && lng != i18n.language) {
      i18n.changeLanguage(lng);
    }
  }, []);

  const { instance, accounts } = useMsal();
  const account = props.account || accounts[0];

  useEffect(() => {
      if (account) {
        instance.acquireTokenSilent({
            scopes: loginRequest.scopes,
            account: account,
            forceRefresh: false
          })
          .then(tokenResult => {
              localStorage.setItem('tkn', tokenResult.accessToken);
              localStorage.setItem('accountInfo', JSON.stringify(account));

              const email = account.username || account.idTokenClaims?.email || account.idTokenClaims?.preferred_username || '';
              const name = account.name || account.idTokenClaims?.name || account.idTokenClaims?.given_name || '';

              getUserDataBackoffice(email).then(data => {
                changeLoginData({
                  customers: [],
                  email: email,
                  id: tokenResult.accessToken,
                  name: name,
                  country: data?.data?.country ?? `BR`
                });                          
              }).catch(() => {
                changeLoginData({
                  customers: [],
                  email: email,
                  id: tokenResult.accessToken,
                  name: name,
                  country: `BR`
                }); 
              })
          })
          .catch((e: any) => {
            console.log("Error acquiring token:", e);
            instance.acquireTokenRedirect({
              scopes: loginRequest.scopes,
              account: account
            });
          })  
      }
  }, [account, instance, changeLoginData]);

 return (
    <>
      <div className={darkMode ? 'dark' : ''}>
        <UniHeader activeRoute={props.activeRoute} logout={props.logout}/> 
        <div className='wrapper'>
          {props.children}
        </div>
        <UniFooter />
      </div>
    </>
  );
}

export default ProtectedApp;
